export default "__VITE_ASSET__7sC6Xoj7__"